import { combineReducers, compose, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "@redux-saga/core";
import { logger, crashReporter } from "../../../store";
import rootSaga from "../sagas";
import {
    subsidiaries,
    subsidiariesLoading
} from "../reducers/subsidiaries.reducer";
import {
    gameEngines,
    gameEnginesLoading,
    enginesSchemas,
    enginesSchemasLoading
} from "../reducers/gameEngines.reducer";
import {
    gameConfigurations,
    gameConfigurationsLoading
} from "../reducers/gameConfigurations.reducer";
import { creationMode } from "../reducers/creationMode.reducer";
/*import {
    gameDetails,
    gameDetailsLoading
} from "../reducers/gameDetails.reducer";*/
import {
    games,
    gamesLoading,
    gamesBySubsidiaryLoading,
    gamesBySubsidiary,
    searchGames,
    searchGamesLoading
} from "../reducers/games.reducer";

import { creatingGame } from "../reducers/creatingGame.reducer";
import { game, gameLoading } from "../reducers/game.reducer";
import { creatingConf } from "../reducers/creatingConf.reducer";
import {
    gameBundles,
    gameBundlesLoading
} from "../reducers/gameBundles.reducer";
import { creatingBundle } from "../reducers/creatingBundle.reducer";
import {
    importJsonLoading,
    importJson,
    creatingAliasLoading
} from "../reducers/importJson.reducer";
import {
    gameAttributesLoading,
    gameAttrFeatures,
    gameAttrFeaturesLoading,
    gameAttrSeries,
    gameAttrSeriesLoading,
    gameAttrPlatforms,
    gameAttrPlatformsLoading,
    gameAttrTypes,
    gameAttrTypesLoading,
    gameAttrTrademarks,
    gameAttrTrademarksLoading,
    clients,
    clientsLoading,
    attrCreationMode,
    attrCreationLoading,
    gameCreationAttributesLoading,
    gameCreationAttributes
} from "../reducers/gameAttributes.reducer";
import {
    denominations,
    denominationsLoading
} from "../reducers/denominations.reducer";

const gamesReducer = combineReducers({
    subsidiaries,
    subsidiariesLoading,
    gameEngines,
    gameEnginesLoading,
    gameConfigurations,
    gameConfigurationsLoading,
    //gameDetails,
    //gameDetailsLoading,
    creationMode,
    enginesSchemas,
    enginesSchemasLoading,
    creatingGame,
    games,
    gamesLoading,
    game,
    gameLoading,
    creatingConf,
    gameBundles,
    gameBundlesLoading,
    creatingBundle,
    gamesBySubsidiary,
    gamesBySubsidiaryLoading,
    importJsonLoading,
    importJson,
    creatingAliasLoading,
    searchGames,
    searchGamesLoading,
    gameAttributesLoading,
    gameAttrFeatures,
    gameAttrFeaturesLoading,
    gameAttrSeries,
    gameAttrSeriesLoading,
    gameAttrPlatforms,
    gameAttrPlatformsLoading,
    gameAttrTypes,
    gameAttrTypesLoading,
    gameAttrTrademarks,
    gameAttrTrademarksLoading,
    clients,
    clientsLoading,
    attrCreationMode,
    attrCreationLoading,
    gameCreationAttributesLoading,
    gameCreationAttributes,
    denominations,
    denominationsLoading
});

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
          name: "Games Store"
      })
    : compose;

const sagaMiddleware = createSagaMiddleware();

export const gamesStore = createStore(
    gamesReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);

export const gamesStoreSelectors = {
    subsidiaries: (state = gamesStore.getState()) => state.subsidiaries,
    subsidiariesLoading: (state = gamesStore.getState()) =>
        state.subsidiariesLoading,
    gameEngines: (state = gamesStore.getState()) => state.gameEngines,
    gameEnginesLoading: (state = gamesStore.getState()) =>
        state.gameEnginesLoading,
    gameConfigurations: (state = gamesStore.getState()) =>
        state.gameConfigurations.results,
    gameConfigurationsCount: (state = gamesStore.getState()) =>
        state.gameConfigurations.count,
    gameConfigurationsLoading: (state = gamesStore.getState()) =>
        state.gameConfigurationsLoading,
    //gameDetails: (state = gamesStore.getState()) => state.gameDetails,
    //gameDetailsLoading: (state = gamesStore.getState()) =>
    //    state.gameDetailsLoading,
    creationMode: (state = gamesStore.getState()) => state.creationMode,
    enginesSchemas: (state = gamesStore.getState()) => state.enginesSchemas,
    enginesSchemasLoading: (state = gamesStore.getState()) =>
        state.enginesSchemasLoading,
    creatingGame: (state = gamesStore.getState()) => state.creatingGame,
    creatingBundle: (state = gamesStore.getState()) => state.creatingBundle,
    games: (state = gamesStore.getState()) => state.games,
    gamesLoading: (state = gamesStore.getState()) => state.gamesLoading,
    game: (state = gamesStore.getState()) => state.game,
    gameLoading: (state = gamesStore.getState()) => state.gameLoading,
    creatingConf: (state = gamesStore.getState()) => state.creatingConf,
    gameBundles: (state = gamesStore.getState()) => state.gameBundles.results,
    gameBundlesCount: (state = gamesStore.getState()) =>
        state.gameBundles.count,
    gameBundlesLoading: (state = gamesStore.getState()) =>
        state.gameBundlesLoading,
    gamesBySubsidiaryLoading: (state = gamesStore.getState()) =>
        state.gamesBySubsidiaryLoading,
    gamesBySubsidiary: (state = gamesStore.getState()) =>
        state.gamesBySubsidiary,
    importJsonLoading: (state = gamesStore.getState()) =>
        state.importJsonLoading,
    importJson: (state = gamesStore.getState()) => state.importJson,
    creatingAliasLoading: (state = gamesStore.getState()) =>
        state.creatingAliasLoading,
    searchGames: (state = gamesStore.getState()) => state.searchGames,
    searchGamesLoading: (state = gamesStore.getState()) =>
        state.searchGamesLoading,
    gameAttributesLoading: (state = gamesStore.getState()) =>
        state.gameAttributesLoading,
    gameAttrFeatures: (state = gamesStore.getState()) => state.gameAttrFeatures,
    gameAttrFeaturesLoading: (state = gamesStore.getState()) =>
        state.gameAttrFeaturesLoading,
    gameAttrSeries: (state = gamesStore.getState()) => state.gameAttrSeries,
    gameAttrSeriesLoading: (state = gamesStore.getState()) =>
        state.gameAttrSeriesLoading,
    gameAttrPlatforms: (state = gamesStore.getState()) =>
        state.gameAttrPlatforms,
    gameAttrPlatformsLoading: (state = gamesStore.getState()) =>
        state.gameAttrPlatformsLoading,
    gameAttrTypes: (state = gamesStore.getState()) => state.gameAttrTypes,
    gameAttrTypesLoading: (state = gamesStore.getState()) =>
        state.gameAttrTypesLoading,
    gameAttrTrademarks: (state = gamesStore.getState()) =>
        state.gameAttrTrademarks,
    gameAttrTrademarksLoading: (state = gamesStore.getState()) =>
        state.gameAttrTrademarksLoading,
    clients: (state = gamesStore.getState()) => state.clients,
    clientsLoading: (state = gamesStore.getState()) => state.clientsLoading,
    attrCreationMode: (state = gamesStore.getState()) => state.attrCreationMode,
    attrCreationLoading: (state = gamesStore.getState()) =>
        state.attrCreationLoading,
    gameCreationAttributesLoading: (state = gamesStore.getState()) =>
        state.gameCreationAttributesLoading,
    gameCreationAttributes: (state = gamesStore.getState()) =>
        state.gameCreationAttributes,
    denominations: (state = gamesStore.getState()) => state.denominations,
    denominationsLoading: (state = gamesStore.getState()) =>
        state.denominationsLoading
};

sagaMiddleware.run(rootSaga);
